import { h, Component } from 'preact';
import Menu from 'preact-material-components/Menu';
import ReactCountryFlag from 'react-country-flag';
import { bind, memoize, debounce } from 'decko';
import { ICountrySelectProps, ICountrySelectState } from './ICountrySelect';
import { CountryInfo } from '../../models/CountryInfo';

let style = require('./style.scss');

export class CountrySelect extends Component<ICountrySelectProps, ICountrySelectState> {

    public menu: Menu;

    constructor(props: any, ctx) {
        super(props, ctx);
        this.setState({
            focused: false,
            selectedIndex:0
        });
    }

    @bind
    public onCountryMenuClick() {
        this.menu.MDComponent.open = true;
        this.setState({ focused: true });
    }

    @bind
    public onMenuClosed() {
        this.setState({ focused: false });
    }

    @bind
    public onMenuSelect(e) {
        this.setState({ selectedIndex: e.detail.index });
        this.props.onSelect && this.props.onSelect(this.props.countries[this.state.selectedIndex]);
    }

    @bind
    public renderItem(c: CountryInfo) {
        return <div class={style.countryItem}>
            <div>
            <div class={style.code}>{c.prefix}</div>
                <div class={style.name}>{c.name}</div>
                </div>
            <div class={style.flag}><ReactCountryFlag code={c.shortCode} svg flagProps={{ fontSize: '2em' }} /></div>            
        </div>
    }

    public render() {
        const effectiveIndex =
        this.props.selectedIndex != null
            ? this.props.selectedIndex
            : this.state.selectedIndex;

        return (
            <Menu.Anchor class={style.menu}>
                <div class={`mdc-text-field mdc-text-field--upgraded ${style.menuDiv} ${this.state.focused ? 'mdc-text-field--focused' : ''}`}>
                    <div class="mdc-text-field__input" onClick={this.onCountryMenuClick}>
                         {effectiveIndex > -1 && this.renderItem(this.props.countries[effectiveIndex])}

                    </div>
                    <label class={`${style.clickThrough} mdc-floating-label ${this.state.focused || effectiveIndex > -1 ? 'mdc-floating-label--float-above' : ''}`}>Country</label>
                    <div class={`mdc-line-ripple ${this.state.focused ? 'mdc-line-ripple--active' : ''}`} style="transform-origin: center center"></div>
                </div>

                <Menu ref={menu => { this.menu = menu; }} onMenuClosed={this.onMenuClosed} onSelect={this.onMenuSelect}>
                    {this.props.countries.map(c => {
                        return <Menu.Item>{this.renderItem(c)}</Menu.Item>;
                    })}
                </Menu>
            </Menu.Anchor>
        );
    }
}






// WEBPACK FOOTER //
// ./components/countrySelect/countrySelect.tsx